if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Aixtra Lights: Fehlermeldung am FIN-Feld/der Checkbox zurücksetzen, sobald der Kunde eingibt/anhakt
        this.form.querySelectorAll('[data-fin-input], [data-fin-checkbox]').forEach((field) => {
          const eventName = field.type === 'checkbox' ? 'change' : 'input';
          field.addEventListener(eventName, () => this.clearFinFieldError(field));
        });

        // Aixtra Lights: merken, ob der Einbauhinweis mindestens einmal geöffnet wurde
        this.form.querySelectorAll('[data-fin-details]').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (details.open) {
              details.setAttribute('data-fin-opened', 'true');
              this.clearFinFieldError(details);
            }
          });
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Aixtra Lights: Produkt darf erst in den Warenkorb, wenn FIN eingetragen und Checkbox bestätigt ist
        if (!this.validateFinFields()) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // Aixtra Lights: Pflichtprüfung für Einbauhinweis (muss geöffnet worden sein),
      // FIN-Feld und Bestätigungs-Checkbox (snippets/fin-configurator.liquid)
      validateFinFields() {
        const checks = [];

        const finDetails = this.form.querySelector('[data-fin-details]');
        if (finDetails) {
          checks.push({
            element: finDetails,
            focusTarget: finDetails.querySelector('summary'),
            isValid: finDetails.hasAttribute('data-fin-opened') || finDetails.open,
          });
        }

        const finInput = this.form.querySelector('[data-fin-input]');
        if (finInput) {
          checks.push({ element: finInput, focusTarget: finInput, isValid: finInput.value.trim().length > 0 });
        }

        const finCheckbox = this.form.querySelector('[data-fin-checkbox]');
        if (finCheckbox) {
          checks.push({ element: finCheckbox, focusTarget: finCheckbox, isValid: finCheckbox.checked });
        }

        let firstInvalid = null;
        checks.forEach((check) => {
          if (check.isValid) {
            this.clearFinFieldError(check.element);
          } else {
            this.showFinFieldError(check.element);
            if (!firstInvalid) firstInvalid = check;
          }
        });

        if (firstInvalid) {
          firstInvalid.element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (firstInvalid.focusTarget) firstInvalid.focusTarget.focus({ preventScroll: true });
          return false;
        }
        return true;
      }

      showFinFieldError(field) {
        const wrapper = field.closest('[data-fin-field]');
        if (!wrapper) return;
        wrapper.classList.add('fin-configurator__field--error');
        const error = wrapper.querySelector('[data-fin-error]');
        if (error) error.removeAttribute('hidden');
      }

      clearFinFieldError(field) {
        const wrapper = field.closest('[data-fin-field]');
        if (!wrapper) return;
        wrapper.classList.remove('fin-configurator__field--error');
        const error = wrapper.querySelector('[data-fin-error]');
        if (error) error.setAttribute('hidden', '');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
